import React, { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa6";
import {
  SelectTest,
  PracticeCard,
} from "../practice-data/Sub-Components/practiceParts";
import PracticeSubjectView from "../practice-data/Sub-Components/PracticeSubjectView";
import TopicPracticeDetail from "../practice-data/Sub-Components/TopicPracticeDetail";
import PracticeSolutions from "../practice-data/practice-solutions/PracticeSolutions";
import { axiosRequest } from "../../../_config/apiClient";

import SscLogo from "../../../assets/exam/ssc.png";
import PoliceLogo from "../../../assets/exam/dehli.png";
import RailwayLogo from "../../../assets/exam/rrb.png";
import IbLogo from "../../../assets/exam/ib.png";
import UpLogo from "../../../assets/exam/up.png";

const Practice = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [activePracticeSet, setActivePracticeSet] = useState(null);

  const [selectedSubject, setSelectedSubject] = useState("");
  const [isSubjectMenuOpen, setIsSubjectMenuOpen] = useState(false);
  const [practiceList, setPracticeList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [subjectList, setSubjectList] = useState([]);
  const [subjectLoading, setSubjectLoading] = useState(false);

  const [topics, setTopics] = useState([]);
  const [loadingTopics, setLoadingTopics] = useState(false);

  const subjects = [
    "General Knowledge",
    "General Science",
    "Logical Reasoning",
    "Quantitative Aptitude",
    "Hindi",
    "English",
    "Current Affairs",
    "Computer Knowledge",
    "Previous Year Questions",
    "GD (Must Attempt Q's)",
  ];

  const fetchPractices = async (search = "") => {
    try {
      setLoading(true);

      const res = await axiosRequest(
        "post",
        "/user/getAllPractice",
        {
          search,
        },
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      );

      setPracticeList(res.data || []);
    } catch (error) {
      console.error("Get Practice Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTopicsBySubject = async (subjectId) => {
    if (!subjectId) {
      setTopics([]);
      return;
    }

    try {
      setLoadingTopics(true);

      const res = await axiosRequest(
        "post",
        "/user/getPapersBySubject",
        { subjectId },
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      );

      setTopics(res.data || []);
    } catch (err) {
      console.error("Get topics error", err);
      setTopics([]);
    } finally {
      setLoadingTopics(false);
    }
  };

  useEffect(() => {
    if (selectedSubject) {
      fetchTopicsBySubject(selectedSubject);
    } else {
      setTopics([]);
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (subjectList.length) {
      setSelectedSubject(subjectList[0]._id);
    } else {
      setSelectedSubject("");
      setTopics([]);
    }
  }, [subjectList]);

  const features = [
    "All Test Series",
    "Reattempt",
    "Detailed solutions and analytics",
  ];
  const displayData = practiceList;

  useEffect(() => {
    fetchPractices();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchPractices(searchQuery);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchQuery]);

  const fetchSubjectsByPractice = async (practiceId) => {
    try {
      setSubjectLoading(true);

      const res = await axiosRequest(
        "post",
        "/user/getSubjectsByPractice",
        { practiceId: practiceId },
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      );

      setSubjectList(res.data || []);
    } catch (error) {
      console.error("Get Subjects Error:", error);
    } finally {
      setSubjectLoading(false);
    }
  };

  useEffect(() => {
    if (selectedExam?._id) {
      fetchSubjectsByPractice(selectedExam._id);
    }
  }, [selectedExam]);

  const handlePracticeSelect = (exam) => {
    setSelectedExam(exam);
  };

  if (activePracticeSet) {
    return <PracticeSolutions onBack={() => setActivePracticeSet(null)} />;
  }

  return (
    <div className="w-full pb-10 font-inter">
      {!selectedTopic && (
        <div className="text-center mt-8 mb-4">
          <h1 className="text-[28px] font-[500] text-[#333333] tracking-[-2px] mb-4">
            Practice Best Questions{" "}
          </h1>
          <div className="flex flex-wrap justify-center gap-[21px]">
            {features.map((feature, idx) => (
              <div key={idx} className="flex items-center gap-[7.5px]">
                <div className="bg-[#21C11E] rounded-full p-1 shadow-sm">
                  <FaCheck className="text-white text-[10px]" />
                </div>
                <span className="text-[16px] font-[500] text-[#333333] tracking-tight">
                  {feature}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mb-10">
        {selectedTopic ? (
          <TopicPracticeDetail
            selectedTopic={selectedTopic}
            onBack={() => setSelectedTopic(null)}
            selectedExam={selectedExam?._id}
            onStart={(level) => setActivePracticeSet(level)}
          />
        ) : !selectedExam ? (
          <SelectTest
            searchValue={searchQuery}
            onSearchChange={(e) => setSearchQuery(e.target.value)}
          />
        ) : (
          <PracticeSubjectView
            selectedExam={selectedExam}
            subjectsFromApi={subjectList}
            selectedSubject={selectedSubject}
            setSelectedSubject={setSelectedSubject}
            topics={topics}
            loadingTopics={loadingTopics}
            onBack={() => setSelectedExam(null)}
            searchValue={searchQuery}
            onSearchChange={(e) => setSearchQuery(e.target.value)}
            onTopicClick={(topic) => setSelectedTopic(topic)}
          />
        )}
      </div>

      {!selectedTopic && (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-9 gap-y-[14px] justify-items-center">
          {displayData.map((exam, idx) => (
            <PracticeCard
              key={exam._id}
              exam={{
                name: exam.name,
                papers: `${exam.paper} Paper`,
                icon: exam.icon,
              }}
              onClick={() => handlePracticeSelect(exam)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Practice;
